/* eslint-disable */
import cn from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { setPopUp } from 'actions/environment';
import ShareLotDialog from 'components/ShareLotDialog';

import styles from './ShareLotButton.scss';
import { withTranslation } from 'react-i18next';
import { shareLot } from '../../actions/collections';

class ShareLotButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      shareId: null,
    };
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  render() {
    const { className, href = '#', building, objectType, profile, lotId, t } = this.props;
    const { modalIsOpen, shareId } = this.state;

    return (
      <div className={cn(styles.PrintWrap, className)}>
        <a
          className={styles.ButtonPrint}
          href={href}
          target="_blank"
          onClick={this.handleClick.bind(this)}
        >
          {t('components.building.chess.sendLot')}
        </a>
        {modalIsOpen ? (
          <ShareLotDialog
            building={building}
            shareId={shareId}
            onClose={this.handleModalClose}
            objectType={objectType}
            profile={profile}
            lotId={lotId}
          />
        ) : null}
      </div>
    );
  }

  handleClick = (e) => {
    e.preventDefault();
    const { shareLot, building, onClick, lotId } = this.props;

    if (onClick) {
      onClick();
    }

    shareLot({ buildingId: building.id, lotId }).then((res) => {
      this.setState({
        modalIsOpen: true,
        shareId: res.data.data.selectionReferal,
      });
    });
  };

  handleModalClose = () => {
    this.setState({
      modalIsOpen: false,
      shareId: null,
    });
  };
}

export default connect(null, {
  setPopUp,
  shareLot,
})(withTranslation()(ShareLotButton));



// WEBPACK FOOTER //
// ./src/components/ShareLotButton/ShareLotButton.js